module.exports = __webpack_public_path__ + "media/components/maps/incidents/icons/travel-099ac5cb8c20d4b1b45a27f085b6137b.png";